import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const miAuditSearchSlice = createSlice({
  name: "miAuditSearch",
  initialState: {
    auditDetails: [],
    allAuditDetailsByDate:[],
    searchedDate:null,
    allAudits:[],
    selectedAudit:null,
  },
  reducers: {
    setAuditDetails(state, action) {
      state.auditDetails = action.payload;
    },
    setAllAuditDetailsByDate(state,action){
    state.allAuditDetailsByDate= action.payload;
    },
    setSearchedDate(state,action) {
      state.searchedDate=action.payload;
    },
    setAudits(state,action){
     state.allAudits= action.payload;
    },
    setSelectedAudit(state,action){
      state.selectedAudit=action.payload;
    }
  }
})